const line1Data = [ // value 只能是 xxx.xx
  {
    name: '平台物流交易总额',
    value: 31.48,
    unit: '万元'
  }, {
    name: '货运吞吐量',
    value: 702.2,
    unit: '万吨'
  }
]

const line3Data = [
  {
    name: '平台订单数',
    value: 2371.1,
    unit: '万单'
  }, {
    name: '入驻企业数量',
    value: 7620,
    unit: '家'
  }, {
    name: '用户访问数',
    value: 6.8,
    unit: 'pv'
  }
]

export {
  line1Data,
  line3Data
}
